document.addEventListener("DOMContentLoaded", () => {
    const disclosures = document.querySelectorAll(".custom-header__menu-disclosure");
    const overlay = document.querySelector(".megamenu-overlay");

    disclosures.forEach((btn) => {
        btn.addEventListener("mouseenter", () => {
            overlay.classList.add("is-visible");
        });

        btn.addEventListener("mouseleave", () => {
            overlay.classList.remove("is-visible");
        });
    });
});